import areaApi from '@/api/config/areaApi'
import { queryKeys } from '@/constant/common'
import { UpdateSubArea } from '@/types/areaZone'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function updateSubAreaItem(payload: UpdateSubArea): Promise<void> {
  await areaApi.updateSubArea(payload)
}

function useUpdateSubArea() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdateSubArea) => updateSubAreaItem(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.areaZone])
      toast.success(t('editSubAreaSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useUpdateSubArea
